import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { AiSourcingService } from 'src/app/_services/ai-sourcing.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import * as _ from 'underscore';
import { ArchiveCandidateModalComponent } from '../archive-candidate-modal/archive-candidate-modal.component';
import { TalentInsightsService } from 'src/app/_services/talent-insights.service';
import { AiSourcingHandlerService } from 'src/app/_services/ai-sourcing-handler.service';
import { Router } from '@angular/router';
import { filter, switchMap } from 'rxjs/operators';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
declare const clevertap;
import { AiSourcingPollingService } from 'src/app/_services/ai-sourcing-polling.service';
import { BlurbackdropComponent } from '../blurbackdrop/blurbackdrop.component';

@Component({
    selector: 'app-ai-sourcing-review',
    templateUrl: './ai-sourcing-review.component.html',
    styleUrls: ['./ai-sourcing-review.component.scss'],
    standalone: false
})
export class AiSourcingReviewComponent implements OnInit, OnDestroy {

  reviewedProfiles: any[] = [];
  tabType: string = 'autopilotTab';
  currentCandidate: any;
  currentIndex: number;
  showCandidate: boolean = false;
  viewMoreSkills: boolean = false;

  projectNumber: string;
  selectedCandididate: any[] = [];
  subscriptions: Array<Subscription> = [];
  successMessage: string = '';
  errorMessage: string = '';
  showLoaderbeforeDataLoad: boolean = false;
  showLoaderforReview: boolean = false;
  projectDetails: any;
  showAISourcingStats: string = '';
  totalCandidatesCount: number = 0;
  showAlert: boolean = false;
  selectedProfiles: any;
  candidateStatus: string = '';
  filterSelected: boolean = false;
  disableMorCandidate: boolean = false;
  showRequested: Boolean = false;
  totalCount: any = {};
  showReviwedCandidates: boolean = false;

  pollingSub: Subscription;
  /**
   * To show ai sourcing progress for a project
   */
  progress: number = 0;
  aiSourcingStatus: string;
  @ViewChild('accessManagementModal') accessManagementModal: TemplateRef<any>;
  blur: boolean = false;
  doNotshowReviewPage: boolean = false;
  reviewpageAccessBlocked: boolean = false;

  constructor(
    private aggregationService: AggregationService,
    private personSearchService: PersonSearchService,
    private aiSourcingService: AiSourcingService,
    private filterDataHandlerService: FilterDataHandlerService,
    private modalService: NgbModal,
    private aiSourcingHandlerService: AiSourcingHandlerService,
    private pollingService: AiSourcingPollingService,
    private router: Router,
    private localStorageService: LocalStorageService,
  ) {
    const filterMethodEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => {
      if (window.location.pathname.includes('ai-sourcing-profiles/review')) {
        if (_methodDetails.methodName == 'clearFilters') {
          if (_methodDetails.source && _methodDetails.source == 'tabChange') {
            return;
          } else {
            this.filterSelected = true;
            this.getReviewProfiles();
          }
        } else { // custom fla
          this.filterSelected = true;
          this.getReviewProfiles();
          return;
        }
      }
    });
    this.subscriptions.push(filterMethodEvent);

  }

  ngOnInit() {

    this.projectNumber = window.location.pathname?.split('/')[4];
    this.getReviewProfiles();
    this.aiSourcingService.getRefreshListEvent.subscribe(res => { this.refreshList(res) });
    this.projectDetails = this.aiSourcingHandlerService.fetchProjectDetails;
    this.aiSourcingHandlerService.progressCompleted$.pipe(
      switchMap(() => this.aiSourcingService.getProjectDetails(this.projectNumber))
    )
      .subscribe((res: any) => {
        if (res.status == 'success') {
          this.projectDetails = res.data;

          this.getReviewProfiles();

          this.showLoaderbeforeDataLoad = false;
        }
      });




    setTimeout(() => {
      const filterRow = document.querySelector<HTMLElement>("#topToReview");
      if (filterRow) {
        const y = filterRow.getBoundingClientRect().top + window.scrollY - 500;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }, 0);



    // this.showModalWithblurBackdrop()
  }
  showModalWithblurBackdrop() {
    // const modalOptions: NgbModalOptions = {
    //   backdropClass: 'custom-backdrop', // Apply the custom class
    //   windowClass: 'blurBackdropModal',
    //    centered: true,
    //    backdrop: 'static',
    //     keyboard: false
    // };
    // this.modalService.open(BlurbackdropComponent, modalOptions);
    document.getElementById('blurModalSection').style.display = 'block'

  }


  getReviewProfiles(status?: string) {
    this.showLoaderbeforeDataLoad = true;
    this.showReviwedCandidates = false;
    this.doNotshowReviewPage = false;
    this.reviewpageAccessBlocked = false;
    const requestObject = this.aggregationService.getRequestWithFilters();
    requestObject['candidatetype'] = 'unactioned';
    this.showLoaderforReview = false;
    requestObject.continentstobeincluded = [];
    this.aiSourcingService.getCandidateList(requestObject, this.projectNumber).subscribe((response: any) => {
      if (response.status == "success") {
        if (response && response.data && response.data.results.length > 0) {
          if (this.projectDetails?.aisourcingstatus == 'started') {
            this.showLoaderbeforeDataLoad = true
            this.pollingSub = this.pollingService.startPolling(this.projectNumber).subscribe(res => {
              this.progress = res.data.progress !== null ? res.data.progress : this.progress;
              if (res.data.progress === 100) {
                this.aiSourcingHandlerService.notifyProgressCompleted();
              }
            });
          } else {
            this.showLoaderbeforeDataLoad = false;
            this.reviewedProfiles = response.data.results || [];
            const status = this.aiSourcingHandlerService.getCurrentValue();
            if (status?.status == 'Getmore' && this.reviewedProfiles.length == 0) {
              this.showLoaderforReview = true;
            } else {
              this.aiSourcingHandlerService.clearData();
              this.showLoaderforReview = false;
            }
            this.totalCandidatesCount = response.data?.candidatecount || 0;
            this.totalCount = response.data?.totalcount || 0;
            if (this.totalCount?.unactioned) {
              if (this.filterSelected == true) this.filterSelected = true;
            } else {
              if (this.filterSelected == true) {
                this.filterSelected = true;
              } else {
                this.filterSelected = false;
              }
            }
            this.aiSourcingHandlerService.setProjectCountEvent({ tab: 'review', count: this.totalCandidatesCount, filterApplied: this.filterSelected, totalCount: this.totalCount });
            this.aiSourcingService.getSelectAllCandidateEvent
              .subscribe(res => {
                if (res?.tab == 'toReview') {
                  this.getSelectAllCandidates(res);
                }
              });
            this.aiSourcingService.emitCandidateListEvent(response.data);
            if (this.projectDetails?.talenteligiblestrength == this.projectDetails?.talentdisplayedsofar) {
              this.filterSelected = false;
            }
          }
          if (this.projectDetails?.status === 'inactive') {
            this.blur = true;
            document.body.classList.add('no-scroll');
          }
        } else {
          this.reviewedProfiles = [];
          this.showLoaderforReview = false;
          this.totalCandidatesCount = response.data?.candidatecount || 0;
          this.totalCount = response.data?.totalcount || 0;
          if (this.totalCount?.unactioned) {
            if (this.filterSelected == true) this.filterSelected = true;
          } else {

              this.filterSelected = false;
            }

          this.showLoaderbeforeDataLoad = false;
          this.aiSourcingHandlerService.setProjectCountEvent({ tab: 'review', count: this.totalCandidatesCount, filterApplied: this.filterSelected, totalCount: this.totalCount });
          console.error('No data found in the response');
        }
      } else {
        this.candidateStatus = 'error';
        this.showLoaderbeforeDataLoad = false;

        console.error('No data found in the response');
      }
    }, (err) => {
      if (err.message == 'no_more_candidates') {
        this.reviewedProfiles = [];
        this.showLoaderbeforeDataLoad = false;
        this.showReviwedCandidates = true;
      } else if (err.status == 403) {
        this.reviewedProfiles = [];
        this.showLoaderbeforeDataLoad = false;
        this.showReviwedCandidates = false;
        if (this.projectDetails?.status == 'inactive') {
          this.doNotshowReviewPage = true;
        }
        if(err.error.errorCode == 'LISTING_BLOCKED') {
          this.reviewpageAccessBlocked = true;
        }
       if (err.error.errorCode == 'AUTOPILOT_ACCESS_DENIED') {
          this.aiSourcingHandlerService.setDisplayPageEvent('landing-page');
          this.router.navigate([`/ai-sourcing`]);
        }
      } else if (err.status == 422) {
       if (err.error.errorCode == 'PROJECT_ACCESS_DENIED') {
            this.aiSourcingHandlerService.setDisplayPageEvent('project-details');
            this.router.navigate([`/ai-sourcing/project-list`]);
        }
      }
    })
  }

  eventHandler(event) {
    if (event.action == 'success') {
      if (event.status == 'shortlist') {
        this.successMessage = 'Candidate successfully shortlisted';
        setTimeout(() => {
          this.successMessage = '';
        }, 5000);
        this.getReviewProfiles('shortlist');

      } else if (event.status == 'archive') {
        this.successMessage = 'Candidate successfully archived';
        setTimeout(() => {
          this.successMessage = '';
        }, 5000);
        this.getReviewProfiles('archive');
      }

    } else {
      setTimeout(() => {
        if (event && event.data && event.data.currentIndex >= 0) {
          event.data.lastseencount = 1;
          this.reviewedProfiles[event.data.currentIndex].lastseencount = 1
        }
      }, 1000)

      var val = event.data.idinindex
      this.reviewedProfiles.find(function (item, i) {
        if (item.idinindex === val) {
          index = i;
          return i;
        }
      });

      var index = -1;

      if (event.action == 'append-data' && event.data != undefined && typeof event.data == 'object') {
        // this.candidateList[event.data.currentIndex] = event.data

        var val = event.data.idinindex
        this.reviewedProfiles.find(function (item, i) {
          if (item.idinindex === val) {
            index = i;
            return i;
          }
        });

        if (event.data && event.data.existingContactDetails) {
          this.reviewedProfiles[index]['existingContactDetails'] = event.data.existingContactDetails;
          this.reviewedProfiles[index]['candidatenumber'] = event.data.candidatenumber;
          this.reviewedProfiles[index] = Object.assign([], this.reviewedProfiles[index]);

        }
        if (event.data && event.data.iswebbtreeverified) {
          this.reviewedProfiles[index]['iswebbtreeverified'] = 1;
        }

        if (event.data && event.data.usedWebbtreeIntroduction) {
          this.reviewedProfiles[index]['usedWebbtreeIntroduction'] = 1;
        }
        if (event.data && event.data.revealContactAttempted) {
          this.reviewedProfiles[index]['revealContactAttempted'] = 1;
        }

      }

      const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');

      if (event.action == 'openNav') {
        //loadn[0].style.display = 'none'
        if (event.type == 'show-contact') {
          this.tabType = 'contactTab'
        } else if (event.type == 'show-activity') {
          this.tabType = 'activityTab'
        } else if (event.type == 'show-skills') {
          this.tabType = 'profileTab'
          this.viewMoreSkills = true;
        }
        else {
          this.tabType = 'autopilotTab'
        }

        if (event.data && event.data.experience && event.data.experience.length && event.data.experience[0].company) {
          const companyObjects = _.pluck(event.data.experience, 'company');
          const payload = companyObjects.map(item => {
            if (item?.id || item?.name) {
              return {
                ...(item?.id && { id: item?.id }),
                ...(item?.name && { name: item?.name })
              }
            }
          }).filter(Boolean);

          this.personSearchService.getCompanyLogoV2(payload).subscribe((res: any) => {
            if (res && res.status == "success") {
              const resultName = res.data
              resultName.forEach(obj => {
                const matchingObj = event.data.experience.filter((item) => ((obj.searchedVia === 'id' && obj.key === item.id) || (obj.searchedVia === 'name' && obj.key === item.name)));
                if (matchingObj && matchingObj.length) {
                  let companyLogo = obj.companylogo
                  matchingObj.forEach(x => {
                    x.companylogo = companyLogo;
                  })

                }
              });

              this.openCandidateSlider(index == -1 ? event.data : this.reviewedProfiles[index], event.currentIndex)
            } else {
              this.openCandidateSlider(index == -1 ? event.data : this.reviewedProfiles[index], event.currentIndex)
            }
          });
        } else {
          this.openCandidateSlider(index == -1 ? event.data : this.reviewedProfiles[index], event.currentIndex)
          //loadn[0].style.display = 'none'
        }



      } else if (event.action == 'closeNav') {
        this.closeNav();
      }
    }


    // this.getLastActivity(event.data.idinindex)
  }

  openCandidateSlider(data, currentIndex) {
    this.currentCandidate = data;
    this.currentIndex = data.currentIndex
    this.showCandidate = true;
    document.getElementById("quickView").style.width = "55%";
    document.getElementById("quickView").style.right = "0";
    document.getElementById("overlay").style.display = "block";
    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
    //loadn[0].style.display = 'none'
  }

  closeNav() {
    this.viewMoreSkills = false;
    this.showCandidate = false
    document.getElementById("quickView").style.width = "0";
    document.getElementById("overlay").style.display = "none";
    document.getElementById("quickView").style.right = "-50px";
    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
    //loadn[0].style.display = 'block'
  }

  getSelectAllCandidates(res) {
    if (res.selectAll == true) {
      this.selectedCandididate = [];
      this.reviewedProfiles.forEach((x: any) => {
        let event = {
          target: {
            checked: true
          }
        }
        this.selectCandidate(event, x);

      })
    } else {
      this.reviewedProfiles.forEach((x: any) => {
        let event = {
          target: {
            checked: false
          }
        }
        x.selected = false;
        this.selectCandidate(event, x);
      })
    }

  }
  closeAlert() {
    this.showAlert = false;
    this.selectedCandididate = []
    this.reviewedProfiles = this.reviewedProfiles.map(x => {
      x.selected = false;
      return x
    })
  }
  selectCandidate(event, candidate) {
    if (event.target.checked) {
      candidate.selected = true;
      event.target.checked = true;
      this.selectedCandididate.push(candidate)
      this.selectedProfiles = this.selectedCandididate.length
      this.showAlert = true;

      // Auto-hide after 3 seconds
      // setTimeout(() => {
      //   this.showAlert = false;
      // }, 3000);

    } else {
      candidate.selected = false;
      event.target.checked = false;
      this.selectedCandididate = this.selectedCandididate.filter(x => x.id !== candidate.id);
    }
    this.aiSourcingService.emitCandidateEvent(this.selectedCandididate);
  }

  changeCandidateStatus(data, status) {
    if (status == 'archive') {
      const modalRef = this.modalService.open(ArchiveCandidateModalComponent, { windowClass: 'genAimodal', centered: true, backdrop: 'static', keyboard: false });
      modalRef.componentInstance.data = data;
      modalRef.componentInstance.projectNumber = this.projectNumber;
      modalRef.componentInstance.calledFrom = 'slider'
      modalRef.componentInstance.passEntry.subscribe((res: any) => {
        if (res === "success") {
          this.successMessage = 'Candidate successfully archived';
          setTimeout(() => {
            this.successMessage = '';
          }, 5000);
          this.getReviewProfiles('archive');
          this.closeNav();
        } else {
          this.errorMessage = 'Error occurred while archiving candidate';
          setTimeout(() => {
            this.errorMessage = '';
          }, 5000);
          this.closeNav();
        }
        /**
* Click on To add to EmailCampaign button
*/
        const archiveParams = {
          "User ID": this.localStorageService.getItem('userdata').userid,
          "Project Number": this.projectNumber,
          "Called From": "Review Slider",
          "ElasticId": data.id

        }
        clevertap.event.push("Autopilot-Archive Candidate", archiveParams);
      });

    } else {
      const payload = {
        projectnumber: this.projectNumber,
        status: status,
        elasticids: [data.id],
      }

      this.aiSourcingService.changeCandidateStatus(payload).subscribe((res: any) => {
        if (res.status === 'success') {
          this.successMessage = 'Candidate successfully shortlisted';
          setTimeout(() => {
            this.successMessage = '';
          }, 5000);
          this.getReviewProfiles('shortlist');
          this.closeNav();
        } else {
          this.errorMessage = 'Error occurred while changing candidate status';
          setTimeout(() => {
            this.errorMessage = '';
          }, 5000);
          this.closeNav();
        }
        /**
        * Click on To add to EmailCampaign button
        */
        const archiveParams = {
          "User ID": this.localStorageService.getItem('userdata').userid,
          "Project Number": this.projectNumber,
          "Called From": "Review Slider",
          "ElasticId": data.id

        }
        clevertap.event.push("Autopilot-Shortlist Candidate", archiveParams);
      }, (err)=>{
        if(err.status === 422){
            this.aiSourcingHandlerService.setDisplayPageEvent('project-details');
            this.router.navigate([`/ai-sourcing/project-list`]);
        }
      })
    }

  }

  refreshList(res) {
    if (res && res.refresh === true) {
      this.getReviewProfiles();
      this.projectDetails = this.aiSourcingHandlerService.fetchProjectDetails;

    }

  }

  getMoreCandidates() {
    this.showLoaderforReview = true;
    this.aiSourcingService.getMoreCandidates(this.projectNumber).subscribe((response: any) => {
      if (response.status == "success") {
        // this.localStorageService.setItem('hideGetMoreCandidate', true);
        this.getReviewProfiles();
        this.showLoaderforReview = false;
        this.aiSourcingHandlerService.setData({ status: 'Getmore' });
        /**
      * Click to re-evaluate
      */
        const emailCampaignParams = {
          "User ID": this.localStorageService.getItem('userdata').userid,
          "Project Number": this.projectNumber

        }
        clevertap.event.push("Autopilot-Get more Candidates", emailCampaignParams);
      } else {
        this.showLoaderforReview = false;
        console.error('No data found in the response');
      }
    }, (err) => {
      if (err.status == 409) {
        this.reviewedProfiles = [];
        this.showLoaderbeforeDataLoad = false;
        this.showReviwedCandidates = true;
        this.showLoaderforReview = false;
      }
    });
  }

  getProjectDetails(res) {
    this.projectDetails = res;
    this.showAISourcingStats = this.projectDetails?.aisourcingstatus;
  }

  redirectToEditCriteria() {
    this.aiSourcingHandlerService.setDisplayPageEvent('project-details');

    this.router.navigate([`/ai-sourcing/project-details/${this.projectNumber}`]);
  }

  get getToCheckIfFiltersApplied() {
    if (this.filterSelected && this.reviewedProfiles.length == 0) {
      return true;
    } else {
      return false;
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if (this.pollingSub) this.pollingSub.unsubscribe();
  }

  openHelpModal() {
    window.open("https://fire-crib-a04.notion.site/How-to-Create-Smart-Autopilot-Criteria-268d71872fa5805abf9bc8914371f5d6");
  }

  get tabClickAccess() {
    if (this.projectDetails?.status === 'inactive') {
      return true;
    }
  }

}
